function load(component) {
    return () =>import (`@/components/${component}.vue`);
};
export default {
    path:"home",
    component:load("home/layout"),
    children:[
        {
            path:"",
            name:"home",
            component:load("home/index"),
            meta: {
                parent: 'home',
                child: 'home',
                deal: true
            }
        },
        {
            path:"homeTip",
            name:"home-tip",
            component:load("home/tip"),
            meta: {
                parent: 'home',
                child: 'home',
                deal: true
            }
        }
    ],
};



// WEBPACK FOOTER //
// ./src/components/home/route/index.js